import { combineReducers } from 'redux';

// REDUX - REDUCERS
import loader from './loader';
import logout from './logout';
import home from './home';
import walletTxns from './walletTxns';

const rootReducer = combineReducers({
	loader,
	logout,
	home,
	walletTxns
});
export default rootReducer;
